import { API_URL } from 'constants';

export const CHATBOT_ASK_URL = `${API_URL}/api/v1/chatbot/ask`;
export const EMPLOYEE_CHATBOT_ASK_URL = `${API_URL}/api/v1/employee-chatbot/ask`;
